<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.8184 5.43284C11.7731 5.43284 5.2512 11.9548 5.2512 20C5.2512 28.0452 11.7731 34.5672 19.8184 34.5672C27.8636 34.5672 34.3855 28.0452 34.3855 20C34.3855 11.9548 27.8636 5.43284 19.8184 5.43284ZM3.81836 20C3.81836 11.1634 10.9818 4 19.8184 4C28.6549 4 35.8184 11.1634 35.8184 20C35.8184 28.8366 28.6549 36 19.8184 36C10.9818 36 3.81836 28.8366 3.81836 20Z"
      class="fill-current"
    />
    <path d="M19 10H20.5V20H19V10Z" class="fill-current" />
    <path d="M30 19V20.5H19V19L30 19Z" class="fill-current" />
  </svg>
</template>
